import React, { useState, useEffect } from "react";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SubsiteService from "../../services/subsite.service";
import Button from "react-bootstrap/Button";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getSubsite, loadSubsite } from "../../reducers/auth";
import { useDispatch } from "react-redux";

const AdminStatus = () => {
  const [value, setValue] = useState('');
  const [deactivateFlag, setDeactivateFlag] = useState('');
  const currentSubsite = useSelector(getSubsite);
  console.log("CURRENT SUBSITE --------", currentSubsite);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      var content = await SubsiteService.getHomepageContent();
      console.log("CONTENT", content);
      setValue(content.siteDown);
    }
    fetchData();   
  }, []);

  const handleUpdate = async () => {
    var content = await SubsiteService.updateSiteDown(value);
  }

  const handleDeactivate = async () => {
    var content = await SubsiteService.toggleSubsiteStatus(false);
    dispatch(loadSubsite(currentSubsite.abbreviation));
  }

  const handleActivate = async () => {
    var content = await SubsiteService.toggleSubsiteStatus(true);
    dispatch(loadSubsite(currentSubsite.abbreviation));
  }

  if(!currentSubsite) {
    return <div>Loading...</div>
  } else 
  return (
    <Container style={{marginTop: 20}}>
      <Row style={{marginTop: 20}}>
        <Col>
          {currentSubsite.active && (
          <><h4>Your Site is Currently: <span style={{color: "#009900"}}>UP</span></h4>
          <Button variant="danger" onClick={handleDeactivate}>
            Deactivate Site
          </Button>
          </>
          )}
          {!currentSubsite.active && (
          <><h4>Your Site is Currently: <span style={{color: "#990000"}}>DOWN</span></h4>
          <Button variant="success" onClick={handleActivate}>
            Activate Site
          </Button>
          </>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
        <hr/>
        </Col>
      </Row>
      <Row style={{marginTop: 20}}>
        <Col>
          <h4>Down Message:</h4>
          <ReactQuill theme="snow" value={value} onChange={setValue} />
          <Button variant="primary" onClick={handleUpdate} style={{marginTop: 10}}>
            Save Down Message
          </Button>
        </Col>
      </Row>
      <Row style={{marginTop: 20}}>
        <Col>
        <h4>Preview Down Message:</h4>
          <div style={{borderWidth: 1, borderColor: "#cccccc"}} dangerouslySetInnerHTML={{ __html: value }}></div>
        </Col>
      </Row>
    </Container>
  );
};
export default AdminStatus;